import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
    name: 'negativeToZero',
    standalone: false
})
export class DbNegativeNumberToZeoPipe implements PipeTransform {
  transform(num: number) {
    return num > 0 ? num : 0;
  }
}
